module.exports = __webpack_public_path__ + "img/home-bg-img.7a91c842.jpg";